import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Camera, Loader2, User } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ApplicantPhoto = ({ app, token, onChanged, onUnauthorized }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const replace = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append('file', file);
    const auth = { Authorization: `Bearer ${token}` };
    try {
      const up = await axios.post(`${API}/admin/upload-photo`, fd, { headers: { ...auth, 'Content-Type': 'multipart/form-data' } });
      await axios.put(`${API}/admin/applications/${app.id}/photo`, { photo: up.data.photo }, { headers: auth });
      onChanged();
    } catch (e) {
      if (e?.response?.status === 401) onUnauthorized();
      else window.alert(e?.response?.data?.detail || 'Photo upload failed');
    } finally { setBusy(false); if (input.current) input.current.value = ''; }
  };

  return (
    <button type="button" className="jbss-app-photo" onClick={() => input.current?.click()} disabled={busy}
      title="Replace photo" data-testid={`admin-application-photo-${app.id}`}>
      {app.photo ? <img src={`${API}/photos/${app.photo}`} alt="" /> : <User size={18} />}
      <span className="jbss-app-photo-edit">{busy ? <Loader2 className="jbss-spin" size={12} /> : <Camera size={12} />}</span>
      <input ref={input} type="file" accept="image/png,image/jpeg,image/webp,image/gif" hidden
        onChange={(e) => replace(e.target.files && e.target.files[0])} data-testid={`admin-application-photo-input-${app.id}`} />
    </button>
  );
};
